/**
 * @generated SignedSource<<3db7b5a7870f6c472ea602d77526455b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ContractRequestStatusEnum = "completed" | "pending" | "rejected" | "started";
export type JobApplicationStatus = "deleted" | "freelancer_not_interested" | "hired" | "interview" | "job_application_draft" | "job_application_invited" | "job_application_sent" | "job_viewed" | "offer" | "potential" | "rejected" | "screening_completed" | "screening_rejected" | "screening_requested" | "screening_started";
export type VideoStatusEnum = "pending" | "processed" | "processing" | "processing_failed" | "processing_queued" | "processing_rejected" | "unprocessed";
export type AnswerListItemStatus_Query$variables = {
  id?: string | null | undefined;
};
export type AnswerListItemStatus_Query$data = {
  readonly video: {
    readonly contractRequests: ReadonlyArray<{
      readonly jobApplication: {
        readonly status: JobApplicationStatus;
      } | null | undefined;
      readonly status: ContractRequestStatusEnum | null | undefined;
    }> | null | undefined;
    readonly rejectReason: string | null | undefined;
    readonly status: VideoStatusEnum;
  } | null | undefined;
};
export type AnswerListItemStatus_Query = {
  response: AnswerListItemStatus_Query$data;
  variables: AnswerListItemStatus_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectReason",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnswerListItemStatus_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Video",
        "kind": "LinkedField",
        "name": "video",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ContractRequest",
            "kind": "LinkedField",
            "name": "contractRequests",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JobApplication",
                "kind": "LinkedField",
                "name": "jobApplication",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnswerListItemStatus_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Video",
        "kind": "LinkedField",
        "name": "video",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ContractRequest",
            "kind": "LinkedField",
            "name": "contractRequests",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JobApplication",
                "kind": "LinkedField",
                "name": "jobApplication",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "175b1674d58d7f4bc858367e74d2e395",
    "id": null,
    "metadata": {},
    "name": "AnswerListItemStatus_Query",
    "operationKind": "query",
    "text": "query AnswerListItemStatus_Query(\n  $id: ID\n) {\n  video(id: $id) {\n    status\n    rejectReason\n    contractRequests {\n      status\n      jobApplication {\n        status\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "15700d0360e688681ecfb00577f5cd10";

export default node;
